<template>
    <AxRoadPage
        :title="$t('ax_road.zones')"
        :closable="$route.name === 'axRoadZones'"
    >
        <template v-if="hasLocationManagementAccess" #header>
            <div class="l-full-width">
                <router-link :to="{ name: 'axRoadAddZone' }">
                    <BaseButton size="medium" variant="light">
                        {{ $t('create') }}
                    </BaseButton>
                </router-link>
            </div>
        </template>

        <AxRoadZonesListItem
            v-for="location in locationsSortedByName"
            :key="location.id"
            :location="location"
        />
    </AxRoadPage>
</template>

<script>
import { mapGetters } from 'vuex'

import AxRoadPage from '@/components/ax-road/AxRoadPage'
import AxRoadZonesListItem from '@/components/ax-road/AxRoadZonesListItem'
import BaseButton from '@/components/redesigned/BaseButton'

export default {
    name: 'ZonesView',
    components: {
        AxRoadPage,
        AxRoadZonesListItem,
        BaseButton,
    },
    data() {
        return {
            assetType: null,
            search: '',
        }
    },
    computed: {
        ...mapGetters('location', ['locationsSortedByName']),
        ...mapGetters('auth', ['hasLocationManagementAccess']),
    },
}
</script>

<i18n>
{
    "en" : {
        "create": "Add"
    },
    "de": {
        "create": "Hinzufügen"
    },
    "fr": {
        "create": "Ajouter"
    },
    "it": {
        "create": "Aggiungi"
    }
}
</i18n>
